// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uf1u","right":"styles_right__28QmW"};